module.exports = __webpack_public_path__ + "img/Jiangsu-power.12000d0b.png";